// Trigger elements need to be regular nodes like <div> or <p>.
export default function isValidTriggerElement(element) {
  return element && (element.nodeType === 1 || element === window);
}



// WEBPACK FOOTER //
// /Users/jamess/webdev/react-projects/materialish/docs/src/vendor/react-over/is-valid-trigger-element.js